import { render } from "./ProductsCard.vue?vue&type=template&id=14bae5cb&scoped=true"
import script from "./ProductsCard.vue?vue&type=script&lang=js"
export * from "./ProductsCard.vue?vue&type=script&lang=js"

import "./ProductsCard.vue?vue&type=style&index=0&id=14bae5cb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\Desktop\\Vue CLI\\new-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bae5cb"]])

export default __exports__